module.exports = __webpack_public_path__ + "img/reporter.94397cb9.png";